import { HANDOVER_TRIP_STATUSES } from '@chukua/common';

/** The office can change a trip's driver only once it has left and until it ends; the server enforces the same rule. */
export function canOfferHandover(tripStatus: string, canDispatch: boolean): boolean {
  return canDispatch && (HANDOVER_TRIP_STATUSES as readonly string[]).includes(tripStatus);
}
